import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';

/* Componente que muestra u oculta un div según el radio button marcado.
 * Hay que hacer cosas raras porque el radio button no lanza el evento
 * change cuando se desmarca entonces tenemos que conectar en todos los
 * radios y al marcar uno, revisar el estado de todos para mostrar el que
 * se marque y ocultar los demás
 */
export default class extends Controller {
  connect() {
    this.#conectarEventos();
  }

  #conectarEventos() {
    this.element.addEventListener('click', () => {
      const url = this.element.dataset.target;
      if (this.element.dataset.turbo === false) {
        window.document.location = url;
      } else {
        Turbo.visit(url);
      }
    });
  }
}
